import React, { useEffect, useState } from "react";
import { Instagram as IgIcon } from "lucide-react";
import { socials } from "../data/categoriesData";

// Live Instagram feed via Behold.so. Loads the widget script once and
// mounts a <behold-widget> custom element with the studio's feed-id.
const BEHOLD_FEED_ID =
  process.env.REACT_APP_BEHOLD_FEED_ID || "Dmj7wbcsq60P6yFSTH1p";

export const InstagramStrip = () => {
  const [scriptOk, setScriptOk] = useState(false);

  useEffect(() => {
    if (!BEHOLD_FEED_ID) return;
    const existing = document.querySelector('script[data-momenta-behold="true"]');
    if (existing) {
      setScriptOk(true);
      return;
    }
    const s = document.createElement("script");
    s.src = "https://w.behold.so/widget.js";
    s.type = "module";
    s.async = true;
    s.dataset.momentaBehold = "true";
    s.onload = () => setScriptOk(true);
    s.onerror = () => setScriptOk(false);
    document.head.appendChild(s);
  }, []);

  return (
    <section
      id="instagram"
      data-testid="instagram-section"
      className="relative bg-black border-t border-white/5 py-16 sm:py-24"
    >
      <div className="max-w-[1600px] mx-auto px-6 sm:px-10 lg:px-14">
        {/* Header — larger, unmistakably Instagram */}
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-10 sm:mb-14">
          <div className="flex items-start gap-4 sm:gap-6">
            <div
              aria-hidden
              data-testid="instagram-icon-frame"
              className="shrink-0 w-14 h-14 sm:w-16 sm:h-16 border border-white/40 flex items-center justify-center bg-white/[0.03]"
            >
              <IgIcon size={28} strokeWidth={1.4} className="text-white" />
            </div>
            <div>
              <h2 className="font-serif text-white text-4xl sm:text-5xl lg:text-6xl font-light tracking-tighter leading-[0.95]">
                Follow on <em className="italic font-medium">Instagram</em>.
              </h2>
              <a
                href={socials.instagram}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="instagram-handle"
                className="mt-3 inline-block font-serif italic text-white/70 hover:text-white text-xl sm:text-2xl link-underline"
              >
                @_momentastudios
              </a>
            </div>
          </div>

          <a
            href={socials.instagram}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="instagram-cta"
            className="group inline-flex items-center gap-3 bg-white text-black hover:bg-white/85 px-6 py-4 text-[11px] tracking-[0.3em] uppercase transition-colors self-start lg:self-end"
          >
            <IgIcon size={16} strokeWidth={1.5} />
            <span>Open on Instagram</span>
            <span className="transition-transform duration-500 group-hover:translate-x-1">↗</span>
          </a>
        </div>

        <div data-testid="instagram-behold" className="behold-wrapper min-h-[200px]">
          {React.createElement("behold-widget", { "feed-id": BEHOLD_FEED_ID })}
          {!scriptOk && (
            <div className="text-white/40 text-[11px] tracking-[0.3em] uppercase mt-3">
              Loading feed…
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default InstagramStrip;
